const html = require("choo/html");
const Icon = require("./icon.js");

module.exports = function Disaplay(args) {
  const {
    icon = null,
    image = null,
    spriteImage = null,
    text = null,
    selected = false,
    size = "medium",
    type = "tight",
    color = "mediumgrey",
    iconSize = "",
    iconAlign = "",
    onClick = () => false,
    hidden = false,
  } = args;
  const charCount = text ? text.length : 0;
  const smallText = charCount > 12 && size === "big" ? "small-text" : "";
  let display = null;
  if (image) {
    display = html`
      <span
        class="icon"
        style="
        background-size: contain;
        background-repeat: no-repeat;
        background-image: url('${image}');
        background-position: center;
        "
      >
      </span>
    `;
  } else if (icon) {
    display = html`<span class="icon ${iconSize} ${iconAlign}">
      ${Icon({ iconName: icon })}
    </span>`;
  } else if (spriteImage) {
    // TODO: consider if this is the best way to display the sprite image here
    display = html`
      <span
        class="icon"
        style="
      /* one background‑size is enough */
      background-image: url('${spriteImage}');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    "
      ></span>
    `;
  }
  let hiddenClass = hidden ? "hidden" : "";

  const selectedClass = selected ? "selected" : "";
  return html`
    <button
      onclick=${onClick}
      class="${hiddenClass} ${type} ${size} ${color} ${selectedClass}  ${smallText} has-icon display"
    >
      ${display}
      <span class="text ${iconAlign}">${text}</span>
    </button>
  `;
};
